import React from "react"
import { ILegendForm } from "./interface"
import { Legend } from "./style"

const LegendForm = (props: ILegendForm) => {

    return (
        <Legend>
            {
                props.children
            }
        </Legend>
    )
}

export default LegendForm